const ThemePageData = {
  theme01: {
    id: "t01",
    pageName: "Autono",
    slug: "autono",
    previewUrl: "https://www.wix.com/demone2/autono",
  },
  theme02: {
    id: "t02",
    pageName: "Autopile",
    slug: "autopile",
    previewUrl: "https://www.wix.com/demone2/autopile",
  },
  theme03: {
    id: "t03",
    pageName: "Benjis Lock And Key",
    slug: "benjis-lock-and-key",
    previewUrl: "https://www.wix.com/demone2/benjis-lock-and-key",
  },
  theme04: {
    id: "t04",
    pageName: "Biz Bud",
    slug: "biz-bud",
    previewUrl: "https://www.wix.com/demone2/bizbud",
  },
  theme05: {
    id: "t05",
    pageName: "Boutique Law Firm",
    slug: "boutique-law-firm",
    previewUrl: "https://www.wix.com/demone2/boutique-law-firm",
  },
  theme06: {
    id: "t06",
    pageName: "Car Showroom",
    slug: "car-showroom",
    previewUrl: "https://www.wix.com/demone2/car-showroom",
  },
  theme07: {
    id: "t07",
    pageName: "Carpenter 2",
    slug: "carpenter2",
    previewUrl: "https://www.wix.com/demone2/carpenter2",
  },
  theme08: {
    id: "t08",
    pageName: "Chicken Farm",
    slug: "chicken-farm",
    previewUrl: "https://www.wix.com/demone2/chicken-farm",
  },
  theme09: {
    id: "t09",
    pageName: "Clic",
    slug: "clic",
    previewUrl: "https://www.wix.com/demone2/clics",
  },
  theme10: {
    id: "t10",
    pageName: "Construction Company",
    slug: "construction-company",
    previewUrl: "https://www.wix.com/demone2/construction-company",
  },
  theme11: {
    id: "t11",
    pageName: "Creative Staffing1",
    slug: "creative-staffing1",
    previewUrl: "https://www.wix.com/demone2/creative-staffing1",
  },
  theme12: {
    id: "t12",
    pageName: "Davon",
    slug: "davon",
    previewUrl: "https://www.wix.com/demone2/davon",
  },
  theme13: {
    id: "t13",
    pageName: "Dean and Brooks",
    slug: "dean-and-brooks",
    previewUrl: "https://www.wix.com/demone2/dean-and-brooks",
  },
  theme14: {
    id: "t14",
    pageName: "Digital Advertising",
    slug: "digital-advertising",
    previewUrl: "https://www.wix.com/demone2/digital-advertising",
  },
  theme15: {
    id: "t15",
    pageName: "Dog Apparel Shop",
    slug: "dog-apparel-shop",
    previewUrl: "https://www.wix.com/demone2/dog-apparel-shop",
  },
  theme16: {
    id: "t16",
    pageName: "Dog Food Online Stor",
    slug: "dog-food-online-stor",
    previewUrl: "https://www.wix.com/demone2/dog-food-online-stor",
  },
  theme17: {
    id: "t17",
    pageName: "Dog Grooming",
    slug: "dog-grooming",
    previewUrl: "https://www.wix.com/demone2/dog-grooming",
  },
  theme18: {
    id: "t18",
    pageName: "Dog Walker",
    slug: "dog-walker",
    previewUrl: "https://www.wix.com/demone2/dog-walker",
  },
  theme19: {
    id: "t19",
    pageName: "Dwell",
    slug: "dwell",
    previewUrl: "https://www.wix.com/demone2/dwell",
  },
  theme20: {
    id: "t20",
    pageName: "Finance Consulting",
    slug: "finance-consulting",
    previewUrl: "https://www.wix.com/demone2/finance-consulting",
  },
  theme21: {
    id: "t21",
    pageName: "Go Solar",
    slug: "go-solar",
    previewUrl: "https://www.wix.com/demone2/go-solar",
  },
  theme22: {
    id: "t22",
    pageName: "Health Coach",
    slug: "health-coach",
    previewUrl: "https://www.wix.com/demone2/health-coach",
  },
  theme23: {
    id: "t23",
    pageName: "Hillside Industries",
    slug: "hillside-industries",
    previewUrl: "https://www.wix.com/demone2/hillside-industries",
  },
  theme24: {
    id: "t24",
    pageName: "Home Remodeli Editor",
    slug: "home-remodeli-editor",
    previewUrl: "https://www.wix.com/demone2/home-remodeli-editor",
  },
  theme25: {
    id: "t25",
    pageName: "It Services",
    slug: "it-services",
    previewUrl: "https://www.wix.com/demone2/it-services",
  },
  theme26: {
    id: "t26",
    pageName: "James Consult Remake",
    slug: "james-consult-remake",
    previewUrl: "https://www.wix.com/demone2/james-consult-remake",
  },
  theme27: {
    id: "t27",
    pageName: "Jenny Gilbert",
    slug: "jenny-gilbert",
    previewUrl: "https://www.wix.com/demone2/jenny-gilbert",
  },
  theme28: {
    id: "t28",
    pageName: "Lawn Care",
    slug: "lawn-care",
    previewUrl: "https://www.wix.com/demone2/lawn-care",
  },
  theme29: {
    id: "t29",
    pageName: "Luxury Real Estate",
    slug: "luxury-real-estate",
    previewUrl: "https://www.wix.com/demone2/luxury-real-estate",
  },
  theme30: {
    id: "t30",
    pageName: "Marketing Firm",
    slug: "marketing-firm",
    previewUrl: "https://www.wix.com/demone2/marketing-firm",
  },
  theme31: {
    id: "t31",
    pageName: "Mechanic",
    slug: "mechanic",
    previewUrl: "https://www.wix.com/demone2/mechanic",
  },
  theme32: {
    id: "t32",
    pageName: "Pet Care",
    slug: "pet-care",
    previewUrl: "https://www.wix.com/demone2/pet-care",
  },
  theme33: {
    id: "t33",
    pageName: "Pet Supply Store",
    slug: "pet-supply-store",
    previewUrl: "https://www.wix.com/demone2/pet-supply-store",
  },
  theme34: {
    id: "t34",
    pageName: "Plantlife",
    slug: "plantlife",
    previewUrl: "https://www.wix.com/demone2/plantlife",
  },
  theme35: {
    id: "t35",
    pageName: "Printa",
    slug: "printa",
    previewUrl: "https://www.wix.com/demone2/ponto-pet",
  },
  theme36: {
    id: "t36",
    pageName: "Printa",
    slug: "printa",
    previewUrl: "https://www.wix.com/demone2/printa",
  },
  theme37: {
    id: "t37",
    pageName: "Real Estate Company",
    slug: "real-estate-company",
    previewUrl: "https://www.wix.com/demone2/real-estate-company",
  },
  theme38: {
    id: "t38",
    pageName: "Real Estate Consult",
    slug: "real-estate-consult",
    previewUrl: "https://www.wix.com/demone2/real-estate-consult",
  },
  theme39: {
    id: "t39",
    pageName: "Real Estate Landing",
    slug: "real-estate-landing",
    previewUrl: "https://www.wix.com/demone2/real-estate-landing",
  },
  theme40: {
    id: "t40",
    pageName: "Social Media Agency",
    slug: "social-media-agency",
    previewUrl: "https://www.wix.com/demone2/social-media-agency",
  },
  theme41: {
    id: "t41",
    pageName: "Success Coach",
    slug: "success-coach",
    previewUrl: "https://www.wix.com/demone2/success-coach",
  },
  theme42: {
    id: "t42",
    pageName: "Unite",
    slug: "unite",
    previewUrl: "https://www.wix.com/demone2/unite",
  },
  theme43: {
    id: "t43",
    pageName: "Vista IO",
    slug: "vista-io",
    previewUrl: "https://www.wix.com/demone2/vista-io",
  },
  theme44: {
    id: "t44",
    pageName: "We Du",
    slug: "we-du",
    previewUrl: "https://www.wix.com/demone2/we-du",
  },
};

export default ThemePageData;
